import { Tab, Transition } from "@headlessui/react";
import { useState } from "react";
import cx from "classnames";
import { VideoGrid } from "./VideoGrid";

type TabbedVideoGroupProps = {
  videos: Record<string, any[]>;
  categories: string[];
};

export const TabbedVideoGroup: React.FC<TabbedVideoGroupProps> = ({
  videos,
  categories
}) => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <div className="content-wrapper">
      <Tab.Group selectedIndex={tabIndex} onChange={setTabIndex}>
        <Tab.List className="flex space-x-1 rounded-xl p-1">
          {categories.map((category, index) => (
            <Tab
              className={cx(
                {
                  "border-coinage-blue": index === tabIndex,
                  "border-[transparent]": index !== tabIndex
                },
                "outline-none text-coinage-blue subhead1 !mr-4 pb-1 border-b-4"
              )}
              key={category}>
              {category}
            </Tab>
          ))}
        </Tab.List>
        <Tab.Panels className="py-6 pt-[45px] tab:pt-6">
          {categories.map((category, index) => (
            <Tab.Panel key={category}>
              <Transition
                appear
                show={tabIndex === index}
                enter="transition-opacity duration-500"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-500"
                leaveFrom="opacity-100"
                leaveTo="opacity-0">
                <VideoGrid
                  showDescription
                  videos={videos[category]}
                  maxVideos={{ desktop: 12, mobile: 4 }}
                  paginate
                />
              </Transition>
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};
